import React from 'react';
import { CusProductListFilterToolbarProps } from '../../cus-product-list.data';

const FilterToolbar = React.forwardRef<HTMLDivElement, CusProductListFilterToolbarProps>(function FilterToolbar(
    { isOpen, activeCount, filterText, clearFiltersText, drawerId, onToggle, onClearAll, variant = 'inline', ariaHidden },
    ref
) {
    const variantClass = variant === 'floating' ? ' bs-product-list__toolbar--floating' : '';

    return (
        <div ref={ref} className={`bs-product-list__toolbar${variantClass}`} aria-hidden={ariaHidden || undefined}>
            <button
                className={`bs-product-list__toolbar__filter-btn${isOpen ? ' --active' : ''}`}
                onClick={onToggle}
                aria-expanded={isOpen}
                aria-controls={drawerId}
                tabIndex={ariaHidden ? -1 : undefined}
            >
                {filterText}
                {activeCount > 0 && ` [${activeCount}]`}
                <span className='bs-product-list__toolbar__filter-btn__icon' aria-hidden='true' />
            </button>
            {activeCount > 0 && (
                <button
                    type='button'
                    className='bs-product-list__toolbar__clear-btn'
                    onClick={onClearAll}
                    tabIndex={ariaHidden ? -1 : undefined}
                >
                    {clearFiltersText}
                </button>
            )}
        </div>
    );
});

export default FilterToolbar;
